import { cordovaExec } from '@services/CandyCaneService'
import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { DeviceLocationServiceConstants } from '@utils/Constants/DeviceLocationServiceConstants'

let retries: number = 10

export const activate = async () => {
    let deviceLocation: any
    console.log('ATBase: Current Environment', EnvironmentDetail.isAndroid())
    if (EnvironmentDetail.isAndroid()) {
        console.log('ATBase: Activating location Service')
        try {
            deviceLocation = await processLocation()
        } catch (error) {
            console.error('ATBase: LocationService: failed to fetch location ', JSON.stringify(error))
            throw error
        }
    } else {
        console.error('ATBase: LocationService: Not an android device')
        throw new Error('Not an android device')
    }
    return deviceLocation
}

/**
 * Call CandyCane location plugin to fetch device location
 * @return Promise
 */
export const getDeviceLocation = async () => {
    console.log('ATBase: LocationService: fetching device location')
    try {
        const response = await cordovaExec(DeviceLocationServiceConstants.LOCATION_PLUGIN, DeviceLocationServiceConstants.ACTION_GET_DEVICE_LOCATION, [])
        console.log('ATBase: LocationService: location received from LocationPlugin: ', JSON.stringify(response))
        return response
    } catch (error) {
        console.error('ATBase: LocationService: error occurred while fetching device location', JSON.stringify(error))
        throw error
    }
}

/**
 * This method will fetch the location until accuracy <= 50 m or for 10s
 * @return location
 */
const processLocation = async () => {
    let currentDeviceLocation: any
    try {
        currentDeviceLocation = await getDeviceLocation()
        console.log('ATBase: ProcessLocation: location received from LocationPlugin: ', JSON.stringify(currentDeviceLocation))
        while (currentDeviceLocation && currentDeviceLocation.Accuracy > 50 && retries > 0) {
            console.log('ATBase: Fetching location from locationPlugin with retries left' , retries - 1)
            console.log('ATBase: locationService: fetched location accuracy > 50m', currentDeviceLocation.Accuracy)
            retries--
            // Waiting for 1 sec before next call
            await new Promise((resolve) => setTimeout(resolve, 1000))
            currentDeviceLocation = await getDeviceLocation()
        }
    } catch (error) {
        console.error('ATBase: LocationService: error occurred while processing location' , JSON.stringify(error))
        console.error('ATBase: Fetching location from locationPlugin with retries left' , retries - 1)
        if (retries > 0) {
            retries--
            await new Promise((resolve) => setTimeout(resolve, 1000))
            currentDeviceLocation = await processLocation()
        } else {
            console.log('ATBase: Retries exhausted not able to fetch the location', error)
            throw error
        }
    }
    retries = 10 // Resetting the retries
    return currentDeviceLocation
}
